import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

import { rootRouteRef } from './routes';

const VendorPerformanceIcon = () => (
  <svg
    aria-hidden="true"
    focusable="false"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    fill="currentColor"
  >
    <path d="M4 20h16v2H2V2h2v18zm3-3v-6h3v6H7zm5 0V7h3v10h-3zm5 0v-8h3v8h-3z" />
  </svg>
);

export const page = PageBlueprint.make({
  params: {
    path: '/vendor-performance',
    routeRef: rootRouteRef,
    title: 'Vendor Performance',
    icon: <VendorPerformanceIcon />,
    loader: () =>
      import('./components/VendorPerformancePage').then(m => (
        <m.VendorPerformancePage />
      )),
  },
});

export const vendorPerformancePlugin = createFrontendPlugin({
  pluginId: 'vendor-performance',
  extensions: [page],
  routes: {
    root: rootRouteRef,
  },
});
